module.exports = __webpack_public_path__ + "img/art-work-icon1.dbd071ce.png";